import {
  type CampaignResponse,
  type CampaignUserResponse,
  type GiftPreviewResponse,
  type StartEmailVerificationResponse,
  type WorkflowProcessResponse
} from "../api/campaign";
import type { ApiResponse } from "../../types/api";
import DummyCampaignUserProvider from "./providers/campaignUser";

export function getCampaign(): Promise<CampaignResponse> {
  return Promise.resolve({
    result: {
      campaign_key: "demo-campaign",
      schedule: {
        periods: [{ starts_at: "2021-01-01T00:00:00Z", ends_at: "2021-01-01T00:00:00Z" }]
      },
      organization_id: 1,
      published_at: "2021-01-01T00:00:00Z",
      domain: "demo-campaign.test.fooji.dev",
      landing_url: "http://demo-campaign.test.fooji.dev",
      is_warming_up: false,
      is_active: true,
      is_running: true,
      is_valid: true,
      period_not_yet_started: false,
      has_ended: false,
      period_has_ended: false,
      is_silenced: false,
      currentOrFormerPeriod: {
        starts_at: 0,
        ends_at: 0,
        silenced_at: 0
      },
      silenced_at: 0,
      starts_at: 0,
      ends_at: 0
    }
  });
}

export function checkCampaignValidity(): Promise<ApiResponse> {
  return Promise.resolve({
    success: true
  });
}

export function getCampaignUser(): Promise<CampaignUserResponse> {
  return Promise.resolve(DummyCampaignUserProvider.get());
}

export function activateWorkflow(addressId: number): Promise<ApiResponse> {
  console.log("Dummy API activateWorkflow with address id:", addressId);
  return Promise.resolve({
    result: {},
    success: true
  });
}

export function continueWorkflow(processKey: string): Promise<ApiResponse> {
  console.log("Dummy API continueWorkflow with processKey", processKey);
  return Promise.resolve({
    result: {},
    success: true
  });
}

export function startEmailVerification(): Promise<StartEmailVerificationResponse> {
  return new Promise<StartEmailVerificationResponse>((resolve) => {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      resolve({
        email: "demo@fooji.com"
      });
    }, 5000);
  });
}

export function getWorkflowInfo(): Promise<WorkflowProcessResponse> {
  return Promise.resolve({
    success: true,
    process: {
      process_key: "process_key",
      metadata: {
        delivery_items: [
          {
            item_key: "item_key",
            variation_key: "variation_key",
            name_key: "name_key",
            image: "/images/microsite-desktop-image.png"
          }
        ],
        "pickup.item": {
          item_key: "item_key",
          variation_key: "variation_key",
          name_key: "name_key",
          image: "/images/microsite-desktop-image.png",
          pickup_location: {
            // Fooji HQ
            latitude: 38.0334412,
            longitude: -84.4936979
          }
        },
        "customer.settings": {
          customer_data: {
            // Fooji HQ
            latitude: 38.0445274,
            longitude: -84.4951775
          }
        }
      }
    }
  });
}

export function resetCampaignUserPhase(): Promise<ApiResponse> {
  return Promise.resolve({
    success: true
  });
}

export function getGiftPreview({
  itemKey,
  variation
}: {
  itemKey: string;
  variation: string;
}): Promise<GiftPreviewResponse> {
  console.debug("Getting gift preview for", itemKey, variation);
  return Promise.resolve({
    success: true,
    gift: {
      visible_name: "Handcrafted Wooden Chair",
      description: "A gift for the home.",
      image: "https://placehold.co/320x400"
    }
  });
}
